import { UpdateNodesContext } from '@/context/UpdateNodesContext';
import { useState } from 'react';

export const UpdateNodesProvider = ({ children }: { children: React.ReactNode }) => {
  const [updateNodes, setUpdateNodes] = useState<string[]>([]);

  return (
    <UpdateNodesContext.Provider
      value={{
        updateNodes: updateNodes,
        setUpdateNodes: setUpdateNodes
      }}
    >
      {children}
    </UpdateNodesContext.Provider>
  );
};
